import { EvaluationRequest, SquareMeterPriceRange } from '../dtos';
import { getClientV1, PUBLIC_API_EVALUATE_PATH } from '../client';

export async function getEvaluation(evaluationRequest: EvaluationRequest): Promise<SquareMeterPriceRange> {
  const client = await getClientV1();
  const { data } = await client.post(PUBLIC_API_EVALUATE_PATH, evaluationRequest);

  return data;
}
